import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { ProductCard } from "../components/ProductCard";
import { Zap, Search } from "lucide-react";

export default function ShopPage() {
  const [products, setProducts] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [q, setQ] = useState("");
  const [cat, setCat] = useState("toate");

  const CATS = [["toate", "Toate"], ["trotineta", "Trotinete"], ["piesa", "Piese"], ["accesoriu", "Accesorii"]];

  useEffect(() => {
    document.title = "Trotinete electrice de vânzare — livrare gratuită | Troti-X Timișoara";
    api.get("/shop/products").then((r) => { setProducts(r.data); setLoaded(true); }).catch(() => setLoaded(true));
  }, []);

  const filtered = products.filter((p) =>
    p.name.toLowerCase().includes(q.toLowerCase()) &&
    (cat === "toate" || (p.category || "trotineta") === cat));

  return (
    <div data-testid="shop-page" className="max-w-7xl mx-auto px-6 py-14">
      <div className="text-[10px] uppercase tracking-[0.3em] text-[#00E5FF] font-bold mb-2">// Magazin</div>
      <h1 className="font-display text-4xl sm:text-5xl uppercase">Magazin <span className="text-[#00E5FF]">Troti-X</span></h1>
      <p className="text-neutral-500 text-sm mt-3 max-w-xl">Trotinete, piese și accesorii verificate de noi în atelier. Livrare gratuită în toată țara, plata cu cardul sau ramburs.</p>

      <div className="flex flex-wrap gap-2 mt-8">
        {CATS.map(([v, l]) => (
          <button key={v} data-testid={`shop-cat-${v}`} onClick={() => setCat(v)}
            className={`px-5 py-2 text-xs uppercase tracking-wider font-bold border transition-colors ${cat === v ? "bg-[#00E5FF] text-black border-[#00E5FF]" : "border-neutral-800 text-neutral-400 hover:border-[#00E5FF]/50 hover:text-white"}`}>
            {l}
          </button>
        ))}
      </div>

      <div className="relative mt-5 max-w-sm">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-neutral-500" />
        <input data-testid="shop-search-input" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cauta model..."
          className="w-full bg-[#0B0B0B] border border-[#00E5FF]/25 focus:border-[#00E5FF] pl-9 pr-4 py-3 text-sm" />
      </div>

      {loaded && filtered.length === 0 ? (
        <div className="border border-dashed border-[#00E5FF]/20 p-20 text-center text-neutral-500 mt-10">
          <Zap className="w-12 h-12 mx-auto mb-4 text-[#00E5FF]/30" />
          {q ? "Niciun produs gasit pentru cautarea ta." : "Produsele sosesc in curand. Revino repede!"}
        </div>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6 mt-10">
          {filtered.map((p) => <ProductCard key={p.id} product={p} />)}
        </div>
      )}
    </div>
  );
}
